/**
 * Default Product Board config document (DB `documents.file_path` after app-docs sync).
 * Used for `/product-board` ? `/doc/...` redirect and deep links.
 */
export const DEFAULT_PRODUCT_BOARD_DOCUMENT_FILE_PATH =
  'flownotes-app-docs/product/product-board.md';
